import { z } from 'zod';

export const uuidSchema = z
    .string({
        required_error: 'нужно указать UUID',
        invalid_type_error: 'значение должно быть строкой (UUID)',
    })
    .uuid('некорректный формат UUID');
